export const LOAD_REPLICAS_REQUEST = 'LOAD_REPLICAS_REQUEST';
export const LOAD_REPLICAS_SUCCESS = 'LOAD_REPLICAS_SUCCESS';
export const LOAD_REPLICAS_FAILURE = 'LOAD_REPLICAS_FAILURE';
export const LOAD_REPLICAS_CANCELLED = 'LOAD_REPLICAS_CANCELLED';

export const NAVIGATION_REPLICATED_TABLE_ID = 'navigation/replicated-table' as const;
